/* HEILMANN HOME · Søgning
   Forslagene hentes fra Shopifys predictive search og renderes af sektionen
   hh-soegeforslag — vi vedligeholder ingen egen ordliste. Samme sektion bruges
   baade i desktop-dropdown og mobil-overlay. */
(function () {
  var SEKTION = 'hh-soegeforslag';
  var GEM = 'hh-seneste-soeg';
  var MAX_SENESTE = 5;
  var rod = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  var sdrop = document.querySelector('[data-hh-sdrop]');
  var smob = document.querySelector('[data-hh-smob]');
  if (!sdrop && !smob) return;

  var desktopInput = document.getElementById('hh-header-soeg');
  var mobilInput = smob ? smob.querySelector('input[type=search]') : null;
  var afbryd = null;
  var timer = null;

  /* ---------- seneste søgninger (kun i denne browser) ---------- */
  function laesSeneste() {
    try { return JSON.parse(localStorage.getItem(GEM)) || []; } catch (e) { return []; }
  }
  function gemSeneste(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    var liste = laesSeneste().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    liste.unshift(q);
    try { localStorage.setItem(GEM, JSON.stringify(liste.slice(0, MAX_SENESTE))); } catch (e) {}
  }
  function tegnSeneste(rodEl) {
    var blok = rodEl.querySelector('[data-hh-seneste]');
    var liste = rodEl.querySelector('[data-hh-seneste-liste]');
    if (!blok || !liste) return;
    var ord = laesSeneste();
    if (!ord.length) { blok.hidden = true; return; }
    liste.innerHTML = ord.map(function (o) {
      var sikker = o.replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
      return '<li><a href="' + rod + 'search?q=' + encodeURIComponent(o) + '">' + sikker + '</a></li>';
    }).join('');
    blok.hidden = false;
  }

  /* ---------- fremhæv det, der matcher ---------- */
  function fremhaev(rodEl, q) {
    if (!q || q.length < 2) return;
    var moenster = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
    rodEl.querySelectorAll('[data-hh-mark]').forEach(function (el) {
      if (el.querySelector('mark')) return;
      el.innerHTML = el.textContent.replace(/[&<>]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
      }).replace(moenster, '<mark>$1</mark>');
    });
  }

  /* ---------- hent forslag ---------- */
  function hent(q, vaert) {
    if (afbryd) afbryd.abort();
    afbryd = new AbortController();
    var url = rod + 'search/suggest?q=' + encodeURIComponent(q || '') +
      '&section_id=' + SEKTION +
      '&resources[type]=product,collection,page,article&resources[limit]=6';
    return fetch(url, { signal: afbryd.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var nyt = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('[data-hh-sdrop-indhold]');
        if (!nyt) return;
        var gammel = vaert.querySelector('[data-hh-sdrop-indhold]');
        if (gammel) gammel.replaceWith(nyt); else vaert.appendChild(nyt);
        fremhaev(nyt, q);
        if (!q) tegnSeneste(nyt);
      })
      .catch(function (e) { if (e.name !== 'AbortError') { /* lad det gamle staa */ } });
  }

  function planlaeg(q, vaert) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { hent(q, vaert); }, 220);
  }

  /* ---------- desktop-dropdown ---------- */
  function aabnDrop() {
    if (!sdrop) return;
    sdrop.classList.add('is-aaben');
    if (desktopInput) desktopInput.setAttribute('aria-expanded', 'true');
    var indhold = sdrop.querySelector('[data-hh-sdrop-indhold]');
    if (indhold && !indhold.dataset.q) tegnSeneste(indhold);
  }
  function lukDrop() {
    if (!sdrop) return;
    sdrop.classList.remove('is-aaben');
    if (desktopInput) desktopInput.setAttribute('aria-expanded', 'false');
  }

  if (desktopInput && sdrop) {
    desktopInput.setAttribute('role', 'combobox');
    desktopInput.setAttribute('aria-expanded', 'false');
    desktopInput.setAttribute('aria-controls', sdrop.id || 'hh-sdrop');

    desktopInput.addEventListener('focus', aabnDrop);
    desktopInput.addEventListener('input', function () {
      aabnDrop();
      planlaeg(desktopInput.value.trim(), sdrop);
    });
    desktopInput.form.addEventListener('submit', function () {
      gemSeneste(desktopInput.value);
    });
    document.addEventListener('click', function (e) {
      if (!sdrop.contains(e.target) && e.target !== desktopInput &&
          !e.target.closest('.hh-header__soegefelt')) lukDrop();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sdrop.classList.contains('is-aaben')) {
        lukDrop();
        desktopInput.blur();
      }
    });
  }

  /* ---------- mobil-overlay ---------- */
  function aabnMob() {
    if (!smob) return;
    smob.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { smob.classList.add('is-aaben'); });
    });
    document.body.style.overflow = 'hidden';
    var indhold = smob.querySelector('[data-hh-sdrop-indhold]');
    if (indhold) tegnSeneste(indhold);
    if (mobilInput) mobilInput.focus();
  }
  function lukMob() {
    if (!smob) return;
    smob.classList.remove('is-aaben');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      if (!smob.classList.contains('is-aaben')) smob.hidden = true;
    }, 450);
  }

  if (smob && mobilInput) {
    mobilInput.addEventListener('input', function () {
      planlaeg(mobilInput.value.trim(), smob.querySelector('[data-hh-smob-body]'));
    });
    mobilInput.form.addEventListener('submit', function () { gemSeneste(mobilInput.value); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && smob.classList.contains('is-aaben')) lukMob();
    });
  }

  /* ---------- matchende kategorier paa soegesiden ----------
     Shopifys soegning kan ikke returnere kollektioner, saa vi henter dem fra
     samme predictive search som dropdownen og viser dem som chips. */
  var katBoks = document.querySelector('[data-hh-soege-kat]');
  if (katBoks) {
    var params = new URLSearchParams(window.location.search);
    var soegt = (params.get('q') || '').trim();
    if (soegt) {
      fetch(rod + 'search/suggest?q=' + encodeURIComponent(soegt) +
            '&section_id=' + SEKTION + '&resources[type]=collection&resources[limit]=6')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var links = doc.querySelectorAll('.hh-sdrop__liste a');
          if (!links.length) return;
          /* Byg chipsene som elementer, ikke som HTML-tekst: textContent er
             allerede afkodet, så "<" i en titel ville ellers blive til kode.
             Kun links til egne /collections/-sider slipper igennem. */
          var h = document.createElement('h2');
          h.className = 'hh-sdrop__h';
          h.textContent = 'Kategorier';
          var chips = [];
          links.forEach(function (a) {
            var href = a.getAttribute('href') || '';
            if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\//i.test(href)) return;
            var chip = document.createElement('a');
            chip.className = 'hh-chip';
            chip.href = href;
            chip.textContent = a.textContent.replace(/\s+/g, ' ').trim();
            chips.push(chip);
          });
          if (!chips.length) return;
          katBoks.textContent = '';
          katBoks.appendChild(h);
          chips.forEach(function (c) { katBoks.appendChild(c); });
          katBoks.hidden = false;
        })
        .catch(function () { /* uden kategorier er siden stadig hel */ });
    }
  }

  /* ---------- fælles klik ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hh-aabn-soeg]')) { e.preventDefault(); aabnMob(); return; }
    if (smob && smob.contains(e.target) && e.target.closest('[data-hh-luk-soeg]')) { lukMob(); return; }

    var ord = e.target.closest('[data-hh-soegeord]');
    if (ord) {
      e.preventDefault();
      var q = ord.getAttribute('data-hh-soegeord');
      var felt = smob && smob.classList.contains('is-aaben') ? mobilInput : desktopInput;
      if (felt) { felt.value = q; felt.focus(); }
      hent(q, smob && smob.classList.contains('is-aaben')
        ? smob.querySelector('[data-hh-smob-body]') : sdrop);
    }
  });
})();
